import $ from 'jquery'
import moment from 'moment'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Image } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import '../../css/pavFiltros/filtros.css'

import ColetaClickstream from '../../components/clickstreamAnalise/clickstreamColeta.js'
import { revelarBarraFiltragem } from '../../redux/actions/index'
import { mudarFiltros, realizouFiltro } from '../../redux/actions/index.js'
import { filtrarVerde } from '../../utils/alternanciaIcones'
import { getTempFiltros } from '../../utils/filtros.js'

import FiltroCentralMensagens from './filtroCentralMensagens'
import FiltroCliente from './filtroCliente'
import FiltroDashboard from './filtroDashboard'
import FiltroDashboardFaturas from './filtroDashboardFaturas'
import FiltroElemento from './filtroElemento'
import FiltroFatConciliacao from './filtroFatConciliacao'
import FiltroFatContestacao from './filtroFatContestacao'
import FiltroFatPlanos from './filtroFatPlanos'
import FiltroFatSimcard from './filtroFatSimcard'
import FiltroFatSolicitacoes from './filtroFatSolicitacoes'
import FiltroFinanceiro from './filtroFinanceiro'
import FiltroMensagens from './filtroMensagens'
import FiltroMigracaoPlano from './filtroMigracaoPlano'
import FiltroModulo from './filtroModulo'
import FiltroAutomacao from './filtroModuloAutomacao'
import FiltroModuloPedidosSimcard from './filtroModuloPedidosSimcard'
import FiltroModuloSmsMensagens from './filtroModuloSmsMensagens'
import FiltroModuloSmsTemplates from './filtroModuloSmsTemplates'
import FiltroPedidosSms from './filtroPedidosSms'
import FiltroPerfil from './filtroPerfil'
import FiltroPessoa from './filtroPessoa'
import FiltroRequestLog from './filtroRequestLog'
import FiltrosDispositivos from './FiltrosDispositivos/index.jsx'
import FiltrosFatContas from './filtrosFatContas'
import FiltrosFatEmpresa from './filtrosFatEmpresa'
import FiltrosFatFaturas from './filtrosfatFaturas'
import FiltroFatFebraban from './filtrosFatFebraban'
import FiltrosFatPedidos from './filtrosFatPedidos'
import FiltrosCicloVida from './filtrosFaturasCicloVida'
import FiltroSistema from './filtroSistema'
import FiltroLogAcesso from './filtrosLogAcesso'
import FiltroSolicitacaoBloqueio from './filtroSolicitacaoBloqueio'
import FiltroSolicitacaoCliente from './filtroSolicitacaoCliente'
import FiltroSolicitacaoOperadora from './filtroSolicitacaoOperadora'
import FiltroTabelaNovoPedidoSms from './filtroTabelaNovoPedidoSms'
import FiltroTela from './filtroTela'
import FiltroUsuarioCliente from './filtroUsuarioCliente'

export default function DropFiltros({
  toggleRevelarDropFiltros,
  setRevelarDropFiltros,
  manejador
}) {
  const modal = useRef()
  const despacho = useDispatch()
  const [foiSelecionado, setFoiSelecionado] = useState(false)
  const [primeiraVez, setPrimeiraVez] = useState(false)
  const [foiLimpado, setFoiLimpado] = useState(false)
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  const handleClickFora = useCallback(
    (e) => {
      if (modal.current.contains(e.target)) return

      //* Verifica se o clique foi dentro do dropdown do Select
      if (e.target.closest('.mantine-Select-dropdown')) return

      //* Verifica se o clique foi dentro do DatePicker
      if (e.target.closest('.mantine-Popover-dropdown')) return

      if (!modal.current?.contains(e.target)) {
        ColetaClickstream(1068) // 'pavFiltrosDropFiltrosHandleClickFora'
        toggleRevelarDropFiltros(false)
      }
    },
    [manejador, toggleRevelarDropFiltros]
  )

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(75) // 'pavFiltrosDropFiltros'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [handleClickFora])

  const enviarFiltros = (event, filtro_arquivo, newItem = false) => {
    event.preventDefault()
    let tempFiltros = getTempFiltros(event.target, filtro_arquivo)

    despacho(realizouFiltro(true))

    if (newItem) {
      tempFiltros = { ...tempFiltros, ...newItem }
    }

    removerPropriedadesPorValor(tempFiltros, 'Selecione')

    if (tempFiltros.DATA_INICIO) {
      tempFiltros.DATA_INICIO = moment(
        tempFiltros.DATA_INICIO,
        'DD/MM/YYYY hh:mm:ss'
      ).toDate()
    }

    if (tempFiltros.DATA_FIM) {
      tempFiltros.DATA_FIM = moment(
        tempFiltros.DATA_FIM,
        'DD/MM/YYYY hh:mm:ss'
      ).toDate()
    }

    despacho(mudarFiltros(tempFiltros))
    despacho(revelarBarraFiltragem(true))
    toggleRevelarDropFiltros(false)
  }

  function removerPropriedadesPorValor(objeto, valor) {
    for (let propriedade in objeto) {
      if (objeto[propriedade] === valor) {
        delete objeto[propriedade]
      }
    }
  }

  const limparFiltros = () => {
    ColetaClickstream(1191) /*dropFiltrosLimpar*/

    $(modal.current)[0].reset()
    setFoiSelecionado(false)
    setFoiLimpado(true)
    despacho(realizouFiltro(true))

    despacho(mudarFiltros({ vazio: 'vazio' }))
    despacho(revelarBarraFiltragem(false))
  }

  function dropFiltros(event, elementoId, imagemId) {
    let elemento = document.getElementById(elementoId)
    let imagem = document.getElementById(imagemId)
    let imagemClasses = document.querySelectorAll(
      '.drop-acoes-menu-icone-ativado'
    )
    let classes = document.querySelectorAll('.dropdown-ativado-filtros')

    if (elemento.classList?.contains('dropdown-desativado-filtros')) {
      if (classes.length > 0) {
        classes.forEach((item) =>
          item.classList.remove('dropdown-desativado-filtros')
        )
        classes.forEach((item) =>
          item.classList.add('dropdown-ativado-filtros')
        )

        imagemClasses.forEach((item) =>
          item.classList.remove('drop-acoes-menu-icone-desativado')
        )
        imagemClasses.forEach((item) =>
          item.classList.add('drop-acoes-menu-icone-ativado')
        )
      }
      elemento.classList.add('dropdown-ativado-filtros')
      elemento.classList.remove('dropdown-desativado-filtros')

      imagem.classList.add('drop-acoes-menu-icone-ativado')
      imagem.classList.remove('drop-acoes-menu-icone-desativado')
    }
    // se o filtro estiver ativado e for clicado em cima do mesmo filtro ele fecha
    else if (elemento.classList?.contains('dropdown-ativado-filtros')) {
      if (classes.length > 0) {
        classes.forEach((item) =>
          item.classList.add('dropdown-desativado-filtros')
        )
        classes.forEach((item) =>
          item.classList.remove('dropdown-ativado-filtros')
        )

        imagemClasses.forEach((item) =>
          item.classList.add('drop-acoes-menu-icone-desativado')
        )
        imagemClasses.forEach((item) =>
          item.classList.remove('drop-acoes-menu-icone-ativado')
        )
      }
      elemento.classList.add('dropdown-desativado-filtros')
      elemento.classList.remove('dropdown-ativado-filtros')

      imagem.classList.add('drop-acoes-menu-icone-desativado')
      imagem.classList.remove('drop-acoes-menu-icone-ativado')
    }

    if (elemento.classList?.contains('dropdown-ativado-filtros')) {
      if (classes.length > 0) {
        classes.forEach((item) =>
          item.classList.add('dropdown-desativado-filtros')
        )
        classes.forEach((item) =>
          item.classList.remove('dropdown-ativado-filtros')
        )

        imagemClasses.forEach((item) =>
          item.classList.add('drop-acoes-menu-icone-desativado')
        )
        imagemClasses.forEach((item) =>
          item.classList.remove('drop-acoes-menu-icone-ativado')
        )
      }
      classes.forEach((item) =>
        item.classList.add('dropdown-desativado-filtros')
      )
      classes.forEach((item) =>
        item.classList.remove('dropdown-ativado-filtros')
      )
    }
  }

  return (
    <div className="posicionador-menu-filtros">
      <Button
        className="botao-filtros-acoes-cabecalho-sistema fundo-cor-7"
        onClick={() => setRevelarDropFiltros(false)}
      >
        <span className="label-filtros-acoes-cabecalho-sistema fonte-cor-1">
          Filtros
        </span>
        <Image
          className="icone-filtros-cabecalho-sistema"
          src={filtrarVerde()}
        />
      </Button>
      {manejador == 'dspDispositivos' && (
        <FiltrosDispositivos
          opened
          limparFiltros={limparFiltros}
          refModal={modal}
          setRevelarDropFiltros={setRevelarDropFiltros}
          toggleRevelarDropFiltros={toggleRevelarDropFiltros}
        />
      )}
      {(manejador == 'cliente' || manejador == 'cadastroCliente') && (
        <FiltroCliente
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'elemento' && (
        <FiltroElemento
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'modulo' && (
        <FiltroModulo
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'perfil' && (
        <FiltroPerfil
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'pessoa' && (
        <FiltroPessoa
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'sistema' && (
        <FiltroSistema
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'tela' && (
        <FiltroTela
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'migracaoPlanoGerenciamento' && (
        <FiltroMigracaoPlano
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'solicitacaoCliente' && (
        <FiltroSolicitacaoCliente
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'solicitacaoOperadora' && (
        <FiltroSolicitacaoOperadora
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'solicitacaoReset' && (
        <FiltroSolicitacaoOperadora
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'tabelaPedidosSms' && (
        <FiltroPedidosSms
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'envioSms' && (
        <FiltroModuloSmsMensagens
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'smsTemplate' && (
        <FiltroModuloSmsTemplates
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'pedidosSimcard' && (
        <FiltroModuloPedidosSimcard
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'financeiro' && (
        <FiltroFinanceiro
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'novoPedidoSMS' && (
        <FiltroTabelaNovoPedidoSms
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'dashboardGeral' && (
        <FiltroDashboard
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'moduloAutomacao' && (
        <FiltroAutomacao
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'mensagens' && (
        <FiltroMensagens
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'solicitacaoBloqueio' && (
        <FiltroSolicitacaoBloqueio
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'centralMensagens' && (
        <FiltroCentralMensagens
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'usuarioCliente' && (
        <FiltroUsuarioCliente
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'fatEmpresa' && (
        <FiltrosFatEmpresa
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'faturasPlanos' && (
        <FiltroFatPlanos
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'faturasCicloVida' && (
        <FiltrosCicloVida
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'fat_solicitacao' && (
        <FiltroFatSolicitacoes
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'con_solicitacao' && (
        <FiltroFatSolicitacoes
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'fatFebraban' && (
        <FiltroFatFebraban
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'fat_contestacao' && (
        <FiltroFatContestacao
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'faturasPedidos' && (
        <FiltrosFatPedidos
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'fatDispositivos' && (
        <FiltroFatSimcard
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
          setRevelarDropFiltros={setRevelarDropFiltros}
        />
      )}
      {manejador == 'faturasConciliacao' && (
        <FiltroFatConciliacao
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'fatConta' && (
        <FiltrosFatContas
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'fatFaturas' && (
        <FiltrosFatFaturas
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'dashboardFaturas' && (
        <FiltroDashboardFaturas
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'requestLog' && (
        <FiltroRequestLog
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
      {manejador == 'acessoLog' && (
        <FiltroLogAcesso
          modal={modal}
          limparFiltros={limparFiltros}
          dropFiltros={dropFiltros}
          enviarFiltros={enviarFiltros}
          foiSelecionado={foiSelecionado}
          setFoiSelecionado={setFoiSelecionado}
          primeiraVez={primeiraVez}
          setPrimeiraVez={setPrimeiraVez}
          foiLimpado={foiLimpado}
          setFoiLimpado={setFoiLimpado}
        />
      )}
    </div>
  )
}
